import $ from 'jquery';

const loadCheckboxRadio = () => {
  $(document).on('click', 'input[type="checkbox"]', function() {
    if ($(this).prop('checked')) $(this).parent().addClass('checked');
    else $(this).parent().removeClass('checked');
  });

  $(document).on('click', 'input[type="radio"]', function() {
    const input = $(this);

    // Set current radio marker
    input.data('current', true);

    // Set checkstate data attr to false if no value set
    if (input.data('checkstate') === undefined) {
      input.data('checkstate', false);
    }

    // Toggle radio display on if selected option not currently selected
    if (input.data('checkstate') === false) {
      input.attr('checked', true);
      input.data('checkstate', true);
      input.closest('label').addClass('checked');
    } else {
      input.attr('checked', false);
      input.data('checkstate', false);
      input.closest('label').removeClass('checked');
    }

    // Reset all radio check displays other than the current one
    input
      .closest('.radio-group')
      .find('.radio-custom')
      .each(function() {
        const input = $(this).find('input');
        const label = $(this).find('label');

        if (input.data('current') !== true) {
          input.attr('checked', false);
          input.data('checkstate', false);
          label.removeClass('checked');
        }
      });

    // Remove current radio marker
    input.data('current', false);
  });
};

export default loadCheckboxRadio;
